var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.91797C6.09449 2.91797 2.91699 6.09547 2.91699 10.0013C2.91699 13.9071 6.09449 17.0846 10.0003 17.0846C13.9062 17.0846 17.0837 13.9071 17.0837 10.0013C17.0837 6.09547 13.9062 2.91797 10.0003 2.91797ZM10.0003 18.3346C5.40533 18.3346 1.66699 14.5963 1.66699 10.0013C1.66699 5.4063 5.40533 1.66797 10.0003 1.66797C14.5953 1.66797 18.3337 5.4063 18.3337 10.0013C18.3337 14.5963 14.5953 18.3346 10.0003 18.3346Z",
    fill: "#2A5AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99512 11.1473C9.65012 11.1473 9.37012 10.8673 9.37012 10.5223V6.83984C9.37012 6.49484 9.65012 6.21484 9.99512 6.21484C10.3401 6.21484 10.6201 6.49484 10.6201 6.83984V10.5223C10.6201 10.8673 10.3401 11.1473 9.99512 11.1473Z",
    fill: "#2A5AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0035 13.9987C9.54268 13.9987 9.16602 13.6262 9.16602 13.1654C9.16602 12.7045 9.53518 12.332 9.99518 12.332H10.0035C10.4643 12.332 10.8368 12.7045 10.8368 13.1654C10.8368 13.6262 10.4643 13.9987 10.0035 13.9987Z",
    fill: "#2A5AFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.cd92484ca565f610099e234de02ce9d0.svg";
export { ForwardRef as ReactComponent };